import './polyfills';

import { QuoteFormController } from './app/quote-form.controller';

const currentScript = document.currentScript;
if (document.readyState !== 'loading') {
    new QuoteFormController(currentScript);
} else {
    document.addEventListener('DOMContentLoaded', () => {
        new QuoteFormController(currentScript);
    })
}


// 'BmTeyfzGRnHpjR2IFXh2Q7AS56v0DqR1VcHDaJwBCPwvvFTwn0BwOPscbTCCoytt';//'esmzytjc9ezmt6dnuzi322upomzvbs6ltib7tos96kkpsa9iqw7n3zlx95v5v8p9',
// "https://lite.serviceos.com/api/v2/external/quotes&quot;

